import axiosConfig from '@/sso/axios-config'

//查询城市数据
export async function getCities(cityCode) {
  const data = {
    cityCode,
  }
  return await axiosConfig.service({
    url: '/common/getCities',
    method: 'post',
    data: data,
  })
}

//查询国家数据
export async function getCountries(countryCode) {
  const data = {
    countryCode,
  }
  return await axiosConfig.service({
    url: '/common/getCountries',
    method: 'post',
    data: data,
  })
}

//查询渠道列表
export async function getCustomerList(param) {
  let data = {
    name: param ? param : undefined,
  }
  return await axiosConfig.service({
    url: '/common/customers',
    method: 'post',
    data: data,
  })
}

//查询供应商数据源
export async function getSupplierList() {
  const data = {}
  return await axiosConfig.service({
    url: '/common/suppliers',
    method: 'post',
    data: data,
  })
}

//查询供应商数据源
export async function queryAllSupplier() {
  const data = {}
  return await axiosConfig.service({
    url: '/common/queryAllSupplier',
    method: 'post',
    data: data,
  })
}

//查询openCid
export async function queryAllOpenCid() {
  const data = {}
  return await axiosConfig.service({
    url: '/common/queryAllOpenCid',
    method: 'post',
    data: data,
  })
}
